import { DataTableClassNames } from '../constants';
import { DefaultDataTableHeaderCell as DefaultHeaderCell } from '../presets';
import { ColumnDef, DataTableSortDirection } from '../types';

import { RowActionHeaderCell } from './RowActionCell';

type Props<TData> = {
  columns: ColumnDef<TData>[];
  hasRowAction: boolean;
  sortKey: keyof TData | undefined;
  sortDirection: DataTableSortDirection;
  onSort: (sortKey: keyof TData, sortDirection: DataTableSortDirection) => void;
};

const HeaderRow = <TData extends Record<string, unknown>>({
  columns,
  hasRowAction,
  sortDirection,
  sortKey,
  onSort,
}: Props<TData>) => {
  const renderHeaderCell = (column: ColumnDef<TData>): React.ReactNode => {
    const { isSortable, key, header = DefaultHeaderCell } = column;

    const isHeaderLabel = typeof header === 'string';

    const currKey = key.toString();

    const label = isHeaderLabel ? header : currKey;

    const Cell = isHeaderLabel ? DefaultHeaderCell : header;

    return (
      <Cell
        columnKey={currKey}
        isSortable={!!isSortable}
        key={currKey}
        label={label}
        sortDirection={sortDirection}
        sortKey={sortKey?.toString()}
        onSort={nextDirection => {
          onSort(currKey, nextDirection);
        }}
      />
    );
  };

  return (
    <tr>
      {columns.map(column => renderHeaderCell(column))}
      {hasRowAction ? (
        <RowActionHeaderCell
          className={DataTableClassNames.Action}
          data-column="_action"
          key={DataTableClassNames.Action}
        />
      ) : undefined}
    </tr>
  );
};

export default HeaderRow;
